import { Box } from "@mui/material"
import { ErrorBoundary } from "ErrorBoundary"
import { Bound } from "lib/@components/binding/Bound"
import { createSlot } from "lib/@components/slot/create-slot"
import useCollapseDrawer from "minimals-template/components/@hooks/useCollapseDrawer"
import { useEffect, useRef, useState } from "react"
import { Outlet } from "react-router"
import DashboardHeader from "routes/@layouts/app/header"
import { MAIN_CONTENT_ID, MainStyle } from "routes/@layouts/app/main-style"
import NavbarVertical from "routes/@layouts/app/navbar/NavbarVertical"
import { SkipLink } from "routes/@layouts/app/skip-link"
import { AfterMainStyle, AfterRoute, BeforeMainStyle, BeforeRoute, MainStyleStart } from "slot-definitions"

export const SystemAdminDashboardHeaderLeft = createSlot("SystemAdminDashboardHeaderLeft")
export const SystemAdminHeaderBarRight = createSlot("SystemAdminHeaderBarRight")

export function SystemAdminAppLayout() {
    const { collapseClick } = useCollapseDrawer()

    const [open, setOpen] = useState(false)
    const ref = useRef()

    useEffect(() => {
        sessionStorage.removeItem("registration-redirect")
    }, [])

    return (
        <Bound openSidebar={openSidebar} closeSidebar={closeSidebar}>
            <SkipLink />
            <Box ref={ref}>
                <Box
                    sx={{
                        display: { lg: "flex" },
                        minHeight: { lg: 1 },
                    }}
                >
                    <DashboardHeader
                        onOpenSidebar={openSidebar}
                        isOpenSidebar={open}
                        slots={{ left: SystemAdminDashboardHeaderLeft, right: SystemAdminHeaderBarRight }}
                    />
                    <NavbarVertical isOpenSidebar={open} onCloseSidebar={closeSidebar} />
                    <BeforeMainStyle.Slot />
                    <MainStyle id={MAIN_CONTENT_ID} tabIndex={-1} collapseClick={collapseClick}>
                        <MainStyleStart.Slot />
                        <Box sx={{ display: "flex", flexDirection: "row", overflow: "auto", height: "100%" }}>
                            <BeforeRoute.Slot />
                            <ErrorBoundary>
                                <Outlet />
                            </ErrorBoundary>
                            <AfterRoute.Slot />
                        </Box>
                    </MainStyle>
                    <AfterMainStyle.Slot />
                </Box>
            </Box>
        </Bound>
    )

    function openSidebar() {
        setOpen(true)
    }

    function closeSidebar() {
        setOpen(false)
    }
}
